module.exports = __webpack_public_path__ + "static/img/keep_benefit_video_display.6e72ce3a.png";